
















































































































































































































import { OrderLine } from '@/interfaces';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DocumentMixin from '@/mixins/DocumentMixin';

@Component
export default class LineDetail extends Mixins(DocumentMixin) {
  @Prop() public readonly rec!: OrderLine;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop() public isArchitect!: boolean;
  @Prop() public version!: string;
}
